module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Mel hated it when her words turned prophetic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Carl Boswell had been past feeling anything at all when she found him. Now she clutched the slim plastic card and the keys she’d removed from his wallet an instant before she’d been discovered going through the dead man’s pockets. She continued to ignore the horrified, sick feeling in her stomach as she paused to get her bearings. She didn’t have time for sick. Not then, and especially not now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the elevated balcony, Mel frantically scanned the noisy crowd below, landing on a tall, imposing figure in an immaculately tailored tuxedo. The stranger moved alertly among the room’s occupants, nodding to acquaintances, but not stopping to speak to anyone. His purposeful stride was carrying him toward the exit at the far end of the ballroom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she skimmed down the stairs keeping her gaze focused on the man, she watched him pinch the bridge of his nose as though he had a headache. Understandable in this din.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He continued on his path with the sense of purpose that had first drawn her eyes—a lean, feral cat among the pigeons. People parted instinctively to let him pass.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not a good mark. He was too alert for that. But she was desperate and his size alone might present a shield. He’d have to do. Everyone else seemed to be with someone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shot a glance over her shoulder. Still clear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel darted amid the clusters of people while trying to keep him in sight. Her spiked heels didn’t add nearly enough height. Fortunately, the stranger was lofty enough that his perfectly groomed, thick dark hair stayed visible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another glance over her left shoulder confirmed the worst. Someone had figured out where she’d gone. A tall man in a perfectly fitted tuxedo appeared on the balcony near the entrance she’d just used.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was not alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mel bit back a groan of dismay. This was bad—very bad. With an imperious sweep of his arm, the man sent two burly security men scurrying into the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her throat went dry. Renewed adrenaline sent her pulse racing faster. Now she blessed her short stature as she ducked behind a man and woman who blocked the aisle. They chatted with a table full of laughing people, oblivious to the others around them. Mel managed what she hoped was a cheerful smile as she edged around the couple, aware of several startled looks from some of those seated there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cursing the shiny beacon of a glittery dress she wore, she kept moving. Her choices had been severely limited after Gary’s frantic call, and the borrowed dress had accomplished its original purpose. No one had questioned her right to join the noisy private party upstairs when she timed her arrival to coincide with a large, boisterous group.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Up there, the gaudy dress had been an asset. Unfortunately, most of the women down here had opted for black, ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("which meant that any minute now one of the men pursuing her would spot the bright kelly-green color. If she could make it to the tall stranger she had a slim chance of getting away.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ODERICK")]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AUGHLIN DRUMMED")]), _vm._v(" his fingers in annoyance as he waited for the coats. His headache seemed to be growing in direct proportion to the noise. The blue haze of cigarette smoke wafting in from the balcony outside added yet another layer to his discomfort. He’d had more than enough frivolity for one evening. As soon as his companion came off the dance floor they were leaving.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Parties like this were Shereen’s forte, not his. To see and be seen was everything in a modeling career and Shereen relished every moment. Roderick, on the other hand, had never been fond of large crowds but he’d promised to bring her tonight, so he had. Still, enough was enough. In his opinion, there were better ways to start a new year.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The pain in his head lightened a bit as he pictured several alternatives. Unfortunately, Shereen wasn’t likely to want to spend the early hours of the new year in bed when she could be dancing and drinking and posing to be admired. Convincing her to leave would probably cost him a fortune for some trinket that had caught her eye. Roderick didn’t care. He wanted to go home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("The young woman manning the coatroom set aside some sort of textbook she’d been studying and returned promptly with his topcoat and the full-length sable fur that had been his Christmas present to Shereen. Shereen wasn’t interested in being politically correct and the coat had caused more than one furrier to throw up his hands in despair. She’d insisted on an exact match for her shoulder-length dark sable tresses. Now that brunettes were all the ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("rage on the runway, the silver fox fur that had matched her hair last year was no longer adequate.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick rubbed fiercely at his temple as he withdrew his wallet and generously tipped the tired-looking woman behind the counter. Anyone who could study an anatomy text in this crush deserved all the help she could get. Her face brightened in gratitude when she saw the bill’s denomination.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With her heartfelt thanks echoing in his ears, he shrugged into his coat and lifted Shereen’s. Mentally he had to admit that the garment had been worth all the effort. Shereen looked exquisite framed in fur, particularly when the coat was all she wore. But then, Shereen looked terrific in anything—and especially in nothing at all. It was her most endearing quality.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick turned, deep in rumination of his new plans for ushering in the new year, and nearly bowled over the petite young woman who had sprung from nowhere to stand directly in his path.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Darling! Thank you. Are we ready to leave now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In a single motion almost faster than the eye could follow, she lifted the sable from his careless fingers and disappeared inside. He only had an instant to notice the shocking bit of glittery green that posed as a dress on her provocative form before both were totally concealed in the voluminous folds of the coat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What the devil do you think you’re doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t even look at him. Her gaze seared the crowd at his back. Instinctively, he raised his head to see what had caused the flash of fear that darkened her lively blue eyes. He was still surveying the crowd when without warning she turned back to him and stretched up on her toes. Clasping his face, she tugged it down to within inches of her own.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least, that’s what he thought she said. Then her lips covered his, whisper-soft and tasting of champagne. Her hands delved beneath the tuxedo’s jacket and slid around his waist. Her enticingly feminine body arched boldly against him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The unexpected kiss was urgent, lacking all trace of finesse. Reckless, almost frantic, her lips moved against his mouth. His shock and annoyance faded under the impact.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her lips were incredibly soft.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The warm, velvety feel stirred an instant, unanticipated reaction. He took control of the kiss without making a conscious decision. Slowly he moved his mouth over hers in a gentle but insistent demand. Her lips parted in surprise. Roderick slid one broad hand beneath the threads of her long, silky hair and cupped the back of her head to deepen the kiss. She froze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d meant to shock her, but he found himself strangely reluctant to let her go. He allowed himself another brief moment to trace the outline of her mouth with his tongue. Startled eyes opened in alarm. Bright crystal blue, they held his gaze as she stood rigidly in his arms. Her breath felt warm against his skin even as Roderick nibbled gently on her bottom lip. He was mildly astonished when she made no effort to pull free of his embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her breathy words sounded puzzled rather than angry. Amusement carved a reluctant smile. “No woman’s ever had to ask me that question before.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The expression that flitted across her features was hard to define and gone in an instant. She dropped her hands from his body.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“I wouldn’t have thought someone so practiced would ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("need to have his ego stroked,” she said with just the slightest hitch in her voice.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick raised his eyebrows letting his enjoyment show. “Ah, but they do say practice makes perfect.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tilted her head to one side. “Uh-huh. If you find a way to market all that practice, you could be a wealthy man one day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He found himself wanting to tell her that he already was a wealthy man and it had nothing to do with his ability to kiss, but discretion stopped him in time. Before he could think of another suitable response, an inebriated man bumped into them. Roderick gripped her arms through the soft fur of the coat to steady her. The man muttered what was probably an apology and kept going. The fascinating young woman looked pointedly down at Roderick’s hand. Only then did he release his hold on the fur.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took another step back and her gaze swiftly darted about the crowd before she trained those amazing eyes back on him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have to leave. If it wouldn’t be too much trouble, do you think you could walk me out?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It hit him then. She was scared. Oh, she had it under tight control, but fear nipped at the edges of her features. Tension pleated her brow as her gaze slid about the room again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What was she afraid of? Several possibilities came to mind. Intrigued, Roderick resisted an impulse to follow her gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Could we hurry?” she demanded breathlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He allowed a quick glance around even as he amazed both of them by tugging her against his side. “All right. Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks. I’ll give you the coat back when we get out of here.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Who was she? What was she doing here?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With his coat thrown over one arm, he held her firmly in place and began to escort her toward the nearby exit, still sheathed in Shereen’s sable fur. Since the music was still playing, it was unlikely that Shereen would miss him for the few minutes it would take to escort this woman down to the lobby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was so much shorter than Shereen that the fur trailed nearly to the floor. She had to move with care to avoid tripping over the hem, but somehow the coat failed to look ludicrous on her—even though it didn’t match her lighter brown hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, not brown, but not quite auburn, either. There were appealing glimpses of red and gold highlights where the overhead chandeliers created glints among the long, curling strands. Most of her hair had been pulled back from her face to cascade down her back, but several strands had escaped, giving her a delightfully tousled look. She’d pulled the sides up and back, holding the hair in place with a simple iridescent green clip. Inexpensive plastic, he noted as she dodged around a crowd that blocked the main exit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t belong here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What was she doing in this room full of wealthy movers and shakers? Security was supposed to be tight at the hotel, although Roderick hadn’t been impressed with what he’d seen. He’d noted several ways a person could get inside without being stopped. Obviously, this woman had used one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unless she was here as a paid companion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He found he didn’t like that disturbing thought, but he couldn’t stop chewing on the idea. It was the dress, of course. Too bold. Too bright. Too cheap.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("No one stopped them as they left the crowded room. As ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("far as Roderick could tell, no one was paying them any attention at all.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Amorous boyfriend?” he asked quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t respond. He wasn’t sure she had heard him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The mezzanine was filled with the overflow from the party. As the loud music faded, his nervous companion continued to dart glances at the crowd as they moved with subtle haste among the revelers. Her agitation was more palpable now. Roderick felt his own senses coming sharply alert. She moved briskly, taking two quick steps to every one of his longer strides. He sensed she was barely restraining a desire to break into a run.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would you like me to slow down?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stay cool,” he advised at this sharp reaction. “No one is watching us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned a fragile, heart-shaped face up to his in surprise. He had the distinct impression that on some level she’d all but dismissed his presence despite the arm he still had around her shoulders. Roderick could honestly say he wasn’t used to being dismissed by anyone, much less a woman he had just kissed. He tamped down an indignant spurt of annoyance. She’d asked for his help. The least she could do was show a little gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not the elevators,” she said impatiently, nudging him away from the press of people waiting before the slow-moving glass cages.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t blame her. He preferred the escalators himself, but probably not for the same reason. As he guided her through the throng, she lifted her face and offered him an unexpected smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Roderick inhaled sharply. She certainly wasn’t a ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("beauty—nothing like Shereen. Her face was too narrow, her chin almost pointy, and those incredibly clear blue eyes were too wide, lending her face a quizzical look. But that smile of hers lit her features and changed everything. A man would overlook any number of flaws to see a smile like that.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re welcome.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She also had gorgeous skin. Shereen spent long hours in front of a mirror trying to achieve the natural, healthy glow that emanated from this slip of a woman. Roderick would bet half his considerable fortune that she had done nothing more to enhance her appearance than to apply lipstick and some eyeliner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Most of the bright red lipstick had been chewed away, but a telltale hint remained. The thin line of eyeliner had smudged, adding to a waiflike appearance that was strangely appealing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because he found himself studying her so closely, he noticed the thin white line at her hairline. The scar was tiny, really. Easily overlooked since it disappeared into her carelessly styled long hair. Still, that jagged line of imperfection was a close match to a scar he carried. His jaw tightened as he remembered the cause of his scar and he wondered how she had come by hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It isn’t every day a man has a chance to play Sir Galahad to a lady in distress,” he told her. Cynically, he had to admit he was sort of enjoying the role. But he couldn’t help wondering exactly what—or whom—he was rescuing her from.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re doing a great job,” she told him, barely glancing up as her gaze continued to rove restlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick frowned. “Do you have a name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course I do.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they stepped onto the descending escalator she hesitated, sending another quick look over her shoulder. Roderick turned back, as well. No one so much as glanced their way. As he withdrew his hand from her shoulder, he gave it a comforting pat. She raised dark sooty lashes to study him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry. I do appreciate your help,” she told him earnestly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mollified, Roderick inclined his head politely, ignoring a renewed stirring of sexual interest. She wasn’t flirting or playing coy, which was just as well. She was not his type. Yet she intrigued him, and he’d have to give her high marks for her ability to think on her feet—not to mention that she didn’t seem the least bit unnerved by him or his size.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t answer my question,” he pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Obviously, she didn’t intend to identify herself or explain this desperate flight. Roderick’s gaze skated to her fingers. Like the rest of her, her hand was small and well shaped. The nails were cropped unfashionably short and were adorned by brilliant scarlet nail polish. He found the color annoyed him the same way his brief glimpse of her daring dress had done. Somehow, neither one belonged on her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could only see her right hand, because the other one was lost in the folds of the coat pulled so tightly around her. To conceal the bright color of her dress, he decided. She wore no jewelry other than a pair of inexpensive crystal earrings. Once again he wondered what she had been doing there. The tickets had been pricey by any standards. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Was")]), _vm._v(" she a paid escort?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("He didn’t like the idea, but it wouldn’t go away. She didn’t have the hardened, jaded look he would have ex")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("pected from a professional, but then, what did he know? He’d never had the need to hire a companion.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Am I in danger of being accosted by an angry husband?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Those soft lips curved with humor. “Worried?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not particularly,” he replied, affronted. “I was curious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was rewarded by the flash of that dazzling smile again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they moved carefully onto the next set of moving stairs he told himself her situation was really none of his business. He didn’t want or need to be involved in her problem, but her caginess was becoming annoying.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She teetered a bit, shifting her stance carefully as she tugged at the trailing coat. For the first time Roderick noticed the height of the glittery green shoes she wore. He was pretty sure the bold color matched her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re going to break your neck in those things if you aren’t careful,” he warned. The heels were slender needles of stupidity. Why she didn’t simply teeter out of them was beyond his comprehension.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once again her ready smile flickered to life. “You could be right. They certainly pinch like the devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He suppressed an answering smile and added spunk to her other attributes. “Why don’t you take them off?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My feet would get cold,” she said reasonably. “Besides, I’d trip over the hem of this coat. Your lady must be a giant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His lips tightened at the reminder of Shereen. If by some chance she had returned to the table and missed him, she would not be in the best of moods when he made it back upstairs. On the other hand, she wouldn’t lack for a partner to take her back out on the dance floor.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“On the contrary,” he told the woman. “Shereen’s the perfect size for a model.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, that explains it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Explains what?” he asked, curious despite himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gave him another of those disarming smiles and shook her head without responding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sanity belatedly surfaced. He knew nothing about this puff of a woman. She could be running from the police for all he knew.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You weren’t an invited guest, were you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tipped back her head to regard him, humor glinting in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What gave me away, the lack of diamonds?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Among other things.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe I find all that flash and dazzle boringly overdone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a woman,” he told her flatly. “Don’t pretend to be so cynical.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Chauvinist. I wouldn’t dream of it. You’ve already perfected that role.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stunned, he watched her step onto the last leg of the escalator. The heavy coat nearly tripped her this time. Roderick steadied her. She nodded her thanks as a subtle awareness hovered between them. He didn’t want to admit it, but she fascinated him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope you and your lady weren’t in a terrible hurry to get home. I’d hate to think I delayed you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Shereen’s apartment isn’t far from here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s good. Thank you, again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t ignoring him now, but wariness had crept in around the edges of her expression. Roderick released the coat and her arm, unsettled by his reluctance to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re welcome, again. I’ll drive you home.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t sure who was more surprised, the woman, or himself. Shereen was probably fuming by now. Or, he conceded more honestly, still dancing with one of her many conquests. They were with a large, boisterous group of acquaintances after all. Still, he couldn’t drive off and leave her there. He needed to go back up and fetch her. First, he’d have the valet bring his car around so his mystery woman could wait inside safely. Shereen would be furious, of course, but even she would see that they couldn’t just leave her at this hour of the night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Where was her coat? Still upstairs? He could bring it down with Shereen. But before he could voice these thoughts, the two of them reached the expansive lobby. The woman stepped forward briskly, turned and slid out of the heavy fur. Lifting up on tiptoes, she placed a chaste kiss on his chin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once more, she’d caught him unprepared. Roderick wasn’t used to being surprised. Things generally went as he planned them. At least they had until she’d waltzed into his life. As she drew away he realized there was no artificial odor of perfume or other fragrance on her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks again, hero. I’m not what you think I am, but I did need rescuing. Happy New Year.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she didn’t wait. She dropped the heavy coat and stepped away. Automatically, Roderick caught the fur before it hit the ground. She hurried off without a backward glance, heels clattering against the marbled floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Roderick had every intention of pursuing her, but stunned, he found his brain still focused on the absurd bit of material she called a dress. There wasn’t much fabric involved. The high mandarin collar and long sleeves were the garment’s deceptive concession to modesty. The key-")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("hole effect in front was so low she looked in immediate danger of disaster.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she was built perfectly for disaster. For such a petite woman, she was incredibly full and lush. The bodice snugged her body like a layer of glittery green skin before it flared out from her waist to swirl about slender, well-shaped calves. It appeared she wasn’t wearing a thing under that dress because in back, the fabric was missing clear down to her coccyx.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“I’m not what you think I am.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t sure what he thought she was, but the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stripper")]), _vm._v(" boldly came to mind. Certainly that clingy, sparkly material begged to be stripped from her enticing form.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick was irritated to find himself aroused. He curbed the impulse to chase after her and demand answers. The lady was a mass of contradictions. That sweetly innocent smile did not go with that dress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the body did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He muttered a low oath. One hand returned to massage his temple as he watched her step outside. He’d managed to forget his headache while he’d been with her, but now it returned with a vengeance. Beyond the plate-glass windows of the lobby, snow billowed in the wind. It wasn’t merely snowing, it was snowing hard. And all he could think was that there was very little of anything covering all that soft bare skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a curse, he strode after her. He reached the double glass doors just in time to see the bellman shut the door of a taxicab.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick paused. The cab would have a heater. She wouldn’t freeze. Obviously she had somewhere to go—someplace private, no doubt—and he did not want to think about watching her strip away that clingy bit of fabric.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roderick shook his head at the disquieting train of thought. Who cared what the woman did with her nights? Hooker, stripper, paid companion…there were plenty of lost souls in Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a growl, he started back across the concourse to the escalator. He wasn’t sure why he was angry, or why her departure left him feeling so dejected. It made no difference who she was running away from. He had problems of his own, not the least of which was getting Shereen to agree to leave the party before midnight so he could go home and relax.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Going up the escalator, he attempted to push the stranger from his thoughts. The unsettling imp would have to fend for herself. She’d already demonstrated an uncanny ability to do just that. There was no reason for concern to jab at him. Nevertheless, he couldn’t help comparing the past few minutes to the ridiculous fairy tale his sister had been so fond of as a child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So this was how the prince had felt when the clock had struck twelve. And while Roderick would hardly consider himself a prince, the only thing missing had been the glass slipper.")])])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page24"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e20fb49e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459232556_ch01.vue
// module id = 81
// module chunks = 0